// extracted by mini-css-extract-plugin
module.exports = {"view-switcher":"view-switcher-3GU_j","viewSwitcher":"view-switcher-3GU_j","icon-wrapper":"icon-wrapper-APxON","iconWrapper":"icon-wrapper-APxON","active":"active-38ULM"};